<div [ngStyle.gt-sm]="{
    'padding-left': '2rem',
    'padding-right': '2rem',
    'padding-bottom': '5rem',
    'width': '80rem',
    'margin-left': 'auto',
    'margin-right': 'auto'
}" [ngStyle.lt-sm]="{
    'padding-left': '1.5rem',
    'padding-right': '1.5rem',
    'margin-left': 'auto',
    'margin-right': 'auto'
}">
  <div style="padding-top: 3rem;">
    <calsoft-text-editor [data]="data" [text]="item?.title" [ngStyle.gt-sm]="{'font-size': item.customField33 }"
      [ngStyle.lt-sm]="{ 'font-size': item.customField34 }">
    </calsoft-text-editor>
  </div>

  <div fxLayoutAlign="start center" fxLayout.xs="column" fxLayout="row wrap" #storyContainer contentAnim
    [aniName]="item.customField36">

    @for (section of images; track section; let i = $index) {
    <div fxFlex="45" class="story-card" [ngStyle.gt-sm]="{
    'margin-right': (i % 2 === 0) ? item.gapBetweenImage : '0px',
    'margin-left': (i % 2 !== 0) ? item.gapBetweenImage : '0px'
  }" [ngStyle.lt-md]="{ 'margin-bottom': '3rem', 'margin-right': '0px' }">
      <div [ngStyle.gt-sm]="{'margin-top': section?.customField30}" class="content-wrapper">
        <div class="image-wrapper1" contentAnim [aniName]="item.customField36">
          <div class="image-wrapper" (click)="link(section.customField35)">
            <img [style.height]="item.customField23" [style.width]="item.customField24"
              [src]="serverPath1 + section.customField8" [alt]="section?.alt" class="scroll-effect">
          </div>
        </div>
        <h3 (click)="link(section.customField35)" contentAnim [aniName]="item.customField36"
          [ngStyle.lt-sm]="{'margin-top': '1rem'}"><calsoft-text-editor [data]="data" [text]="section?.customField6"
            [ngStyle.lt-sm]="{'font-size': item.customField28,'margin-bottom':'0px'}"
            [ngStyle.gt-sm]="{'font-size': item.customField27 }">
          </calsoft-text-editor></h3>
        <p (click)="link(section.customField35)" contentAnim [aniName]="item.customField36"><calsoft-text-editor
            [data]="data" [text]="section?.customField7"
            [ngStyle.lt-sm]="{'font-size': item.customField31,'margin-top':'0px'}"
            [ngStyle.gt-sm]="{'font-size': item.customField29 }">
          </calsoft-text-editor></p>
      </div>
    </div>
    }
  </div>
</div>